export default "__VITE_ASSET__bYgUzQLA__"